import { render, staticRenderFns } from "./editHelp.vue?vue&type=template&id=d321a244"
import script from "./editHelp.vue?vue&type=script&lang=js"
export * from "./editHelp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports